import { createContext, useContext } from 'react';
import type { UIDefinition, BindingContext } from '@fias/sdui-types';

export interface ArcheContextValue {
  // UI Definition
  ui: UIDefinition | null;

  // Current page
  currentPage: string;

  // Binding context for resolving expressions
  context: BindingContext;

  // Request state
  requestId: string | null;
  archId: string;
  archeName: string;

  // Loading state
  isLoading: boolean;
  error: string | null;
}

export const ArcheContext = createContext<ArcheContextValue | null>(null);

// Default context for use outside ArcheProvider (e.g., SDUI Preview)
const defaultContext: ArcheContextValue = {
  ui: null,
  currentPage: 'main',
  context: {
    input: {},
    output: {},
    user: { id: 'preview-user', displayName: 'Preview User' },
    arche: { id: 'preview', name: 'Preview' },
    request: { id: 'preview-request', currentPage: 'main' },
  },
  requestId: null,
  archId: 'preview',
  archeName: 'Preview',
  isLoading: false,
  error: null,
};

export function useArcheContext(): ArcheContextValue {
  const context = useContext(ArcheContext);
  if (!context) {
    // Return a default implementation for preview/testing
    return defaultContext;
  }
  return context;
}

export default useArcheContext;
